import qs from 'query-string';
import { get, post, put, patch, del } from './baseApi';

export const BovineApi = {
    fetch: (query, options) => get(`/bovines?${qs.stringify(query)}`, options),
    fetchSummary: (query) => get(`/bovines/summary?${qs.stringify(query)}`),
    fetchById: (id) => get(`/bovines/${id}`),
    fetchHistory: (id, query) => get(`/bovines/${id}/history?${qs.stringify(query)}`),
    updateHistory: (bovineId, id, data) => put(`/bovines/${bovineId}/history/${id}`, data),
    deleteHistory: (bovineId, id) => del(`/bovines/${bovineId}/history/${id}`),
    create: (data) => post('/bovines', data),
    update: (id, data) => put(`/bovines/${id}`, data),
    patch: (id, data, options) => patch(`/bovines/${id}`, data, options),
    delete: (id) => del(`/bovines/${id}`),
    fetchTypes: (query = { order: 'asc' }) => get(`/bovines/types?${qs.stringify(query)}`),
    fetchStatus: (query = { order: 'asc' }, options) => get(`/bovines/status?${qs.stringify(query)}`, options),
    fetchByLot: (lotId, query) => get(`/farms/lots/${lotId}/bovines?${qs.stringify(query)}`),
    export: (query, format, template) => get(`/bovines/export/${format}/${template || ''}?${qs.stringify(query)}`, { responseType: 'blob' }),
    getReportByType: (query) => get(`/bovines/reports/type?${qs.stringify(query)}`),
    getReportByLot: (query) => get(`/bovines/reports/lot?${qs.stringify(query)}`),
    getReportByRegistration: (query) => get(`/bovines/reports/registration?${qs.stringify(query)}`),
    importParse: (data, options) => post('/bovines/import/parse', data, options),
    importQueue: (data, options) => post('/bovines/import/queue', data, options),
    import: (data, options) => post('/bovines/import', data, options),
    findIds: (data, options) => post('/bovines/ids', data, options),
};
